import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { Analytics } from "@/components/Analytics";
import { CookieBanner } from "@/components/CookieBanner";
import { CookieConsentProvider } from "@/lib/cookieConsent";
import { Home } from "@/pages/Home";
import { Om } from "@/pages/Om";
import { Ydelser } from "@/pages/Ydelser";
import { Rotter } from "@/pages/ydelser/Rotter";
import { Kloak } from "@/pages/ydelser/Kloak";
import { Service } from "@/pages/ydelser/Service";
import { NoDig } from "@/pages/ydelser/NoDig";
import { Spul } from "@/pages/ydelser/Spul";
import { Forsikring } from "@/pages/segments/Forsikring";
import { Hovedentreprenoerer } from "@/pages/segments/Hovedentreprenoerer";
import { Forsyninger } from "@/pages/segments/Forsyninger";
import { Kontakt } from "@/pages/Kontakt";
import { BookRedirect } from "@/pages/BookRedirect";
import { NotFound } from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <CookieConsentProvider>
        <BrowserRouter>
          <Analytics />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/om-os" element={<Om />} />
              <Route path="/ydelser" element={<Ydelser />} />
              <Route path="/ydelser/rottebekaempelse" element={<Rotter />} />
              <Route path="/ydelser/kloakopgaver" element={<Kloak />} />
              <Route path="/ydelser/serviceaftale" element={<Service />} />
              <Route path="/ydelser/no-dig" element={<NoDig />} />
              <Route path="/ydelser/spul-rens" element={<Spul />} />
              <Route path="/forsikring" element={<Forsikring />} />
              <Route path="/hovedentreprenoerer" element={<Hovedentreprenoerer />} />
              <Route path="/forsyninger" element={<Forsyninger />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/book" element={<BookRedirect />} />

              {/* 301-redirects fra gamle URL-stier (den gamle WordPress-side) */}
              <Route path="/rottebekaempelse" element={<Navigate to="/ydelser/rottebekaempelse" replace />} />
              <Route path="/kloakopgaver" element={<Navigate to="/ydelser/kloakopgaver" replace />} />
              <Route path="/serviceaftale" element={<Navigate to="/ydelser/serviceaftale" replace />} />
              <Route path="/no-dig" element={<Navigate to="/ydelser/no-dig" replace />} />
              <Route path="/spul-rens" element={<Navigate to="/ydelser/spul-rens" replace />} />
              <Route path="/cases" element={<Navigate to="/" replace />} />

              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <CookieBanner />
      </CookieConsentProvider>
    </div>
  );
}

export default App;
